import { observable } from "mobx";
import { Type } from "class-transformer";
import AccountingDocumentsInventoryDetailAccessActionResponse from "./accountingDocumentsInventoryDetailAccessActionResponse";
import AccountingDocumentsInventoryCheckResultDownloadActionResponse from "./accountingDocumentsInventoryCheckResultDownloadActionResponse";
import AccountingDocumentsInventoryChangeActionResponse from "./accountingDocumentsInventoryChangeActionResponse";
import AccountingDocumentsInventoryCheckActionResponse from "./accountingDocumentsInventoryCheckActionResponse";
import AccountingDocumentsInventoryDeletionActionResponse from "./accountingDocumentsInventoryDeletionActionResponse";
import AccountingDocumentsInventoryClosureActionResponse from "./accountingDocumentsInventoryClosureActionResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class AccountingDocumentsInventoryPermittedActionsResponse {
  @observable
  @Type(() => AccountingDocumentsInventoryDetailAccessActionResponse)
  inventoryDetailAccess!: AccountingDocumentsInventoryDetailAccessActionResponse;

  @observable
  @Type(() => AccountingDocumentsInventoryCheckResultDownloadActionResponse)
  inventoryCheckResultDownload!: AccountingDocumentsInventoryCheckResultDownloadActionResponse;

  @observable
  @Type(() => AccountingDocumentsInventoryChangeActionResponse)
  inventoryChange!: AccountingDocumentsInventoryChangeActionResponse;

  @observable
  @Type(() => AccountingDocumentsInventoryCheckActionResponse)
  inventoryCheck!: AccountingDocumentsInventoryCheckActionResponse;

  @observable
  @Type(() => AccountingDocumentsInventoryDeletionActionResponse)
  inventoryDeletion!: AccountingDocumentsInventoryDeletionActionResponse;

  @observable
  @Type(() => AccountingDocumentsInventoryClosureActionResponse)
  inventoryClosure!: AccountingDocumentsInventoryClosureActionResponse;
}
